// extracted by mini-css-extract-plugin
export var falseIcon = "trueOrFalse-module--falseIcon--dcb09";
export var trueIcon = "trueOrFalse-module--trueIcon--064ea";
export var wrapper = "trueOrFalse-module--wrapper--68e9a";